import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {StatisticState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: StatisticState = {
    mnStatisticDetail: null,
    mnStatisticGroup: null,
    mnGroupings: {
        mnGroup: [
            'hour',
            'day',
            'week',
            'month',
        ],
        mnGroupOptionally: [
            'broker_account_login',
            'mn_service_name',
            'mn_tmpl',
            'routes',
            'message_type',
            'bulk_id',
            'template_id',
        ],
    },
};


export const mnStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
